import { Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Первая плитка сетки: «Создать инструкцию». Размером и скруглением — как плитка инструкции;
 *  на телефоне — невысокая полоса-кнопка, как «Создать курс». */
export const CreateInstructionTile = () => {
  const navigate = useNavigate()
  const m = useMessages(messages)
  return (
    <button
      type="button"
      onClick={() => navigate('/instructions/new')}
      className="group flex h-16 w-full flex-row items-center justify-center gap-3 rounded-2xl md:aspect-[4/5] md:h-auto md:flex-col border-2 border-dashed border-foreground/15 text-base text-muted-foreground outline-none transition-colors hover:border-brand/50 hover:bg-brand/5 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring"
    >
      <span className="flex size-9 items-center justify-center rounded-full bg-brand/15 text-brand transition-transform group-hover:scale-105 md:size-14">
        <Plus className="size-5 md:size-7" />
      </span>
      {m.createInstruction}
    </button>
  )
}
